import { COMMON_STRING } from '@/constants/dictionary';
import { useImageObjectUrl } from '@/service/hooks/useImageObjectUrl';
import { MTDialog } from '../common/MTDialog';

export type ScorerPhotoDialogProps = {
  onClose: VoidFunction;
  photo?: string | null;
  open: boolean;
  fullName: string;
};

export const ScorerPhotoDialog = ({
  onClose,
  photo,
  open,
  fullName,
}: ScorerPhotoDialogProps) => {
  const imageUrl = useImageObjectUrl(open ? photo : null);

  return (
    <MTDialog
      open={open}
      onClose={onClose}
      title={`${COMMON_STRING.DATA_COLLECTOR} - ${fullName}`}
    >
      <img
        src={imageUrl || ''}
        alt='Full size'
        style={{
          maxWidth: '100%',
          maxHeight: '80vh',
          objectFit: 'contain',
          display: 'block',
        }}
      />
    </MTDialog>
  );
};
